import React, { useEffect } from "react"
import PublicSiteHeader from "./PublicSiteHeader"
import PublicSiteFooter from "./PublicSiteFooter"

/**
 * Guest marketing shell for public city pages.
 */
const PublicSiteLayout = ({ children }) => {
  useEffect(() => {
    document.body.classList.add("public-site-body")
    return () => {
      document.body.classList.remove("public-site-body")
    }
  }, [])

  return (
    <div className="public-site">
      <PublicSiteHeader />
      <main className="public-site__main" id="content">
        {children}
      </main>
      <PublicSiteFooter />
    </div>
  )
}

export default PublicSiteLayout
